import type { PortfolioActivityReactionResource } from "api/generated";
import type { PortfolioActivityReaction } from "portfolio/types";
import { mapShallowTeacher } from "shared/mappers";

export const portfolioActivityReactionFromDto = (
  data: PortfolioActivityReactionResource,
): PortfolioActivityReaction => ({
  id: data.id,
  systemMessage: data.system_message,
  user: data?.user ? mapShallowTeacher(data.user) : null,
  shortage: data.shortage,
  message: data.message,
  isSender: data.is_sender,
  createdAt: data.created_at ? new Date(data.created_at) : null,
  editedAt: data.edited_at ? new Date(data.edited_at) : null,
});
